import { useQuery } from '@hooks/reactQuery';

import { getOrganisations } from '@api/organisations';

import { extractQueryParams } from '@utils/common';

import { IGetOrganisationsDTO } from '@interfaces/organisation/dto/organisationsDTO';

import { ORGANISATIONS } from '@constants/queryKeys';

export const useQueryOrganisationsByFilter = (params?: IGetOrganisationsDTO) => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
			queryKey: [
				ORGANISATIONS,
				params,
			],
			queryFn: extractQueryParams(getOrganisations),
			refetchOnWindowFocus: false,
		},
	);

	return {
		organisations: data?.items || [],
		countOfRecords: data?.count || 0,
		isLoadingOrganisations: isInitialLoading,
	};
};
